import { Box, useToast } from '@chakra-ui/react'
import { FC, useMemo } from 'react'
import Highlighter from 'react-highlight-words'

import useOtbPlan from '@hook/Otb/use-plan'
import useTable from '@hook/shared/use-table'

import { parseCurrency } from '@helper/parseCurrency'
import { removeCurrencyMask } from '@helper/removeCurrentyMask'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

interface ITableGridItemKpiSales {
  [key: string]: any
  undoValue?: number
  updatedFinalStorage?: (value: string, data: any) => void
}

export const TableGridItemOtbPlan: FC<ITableGridItemKpiSales> = ({
  data,
  updatedFinalStorage
}) => {
  const toast = useToast()
  const { columns, query } = useTable()
  const { handleUpdateGrowthWanted } = useOtbPlan()

  const isCurrentDate = useMemo(() => {
    const currentMonth = new Date().getMonth()
    const month = data['empresa-mes']

    return Number(month) === currentMonth + 1
  }, [data])

  const handleLineSelect = (target: any) => {
    const tagName = target.parentNode.parentNode.tagName
    const element = document.querySelector('.select-line')
    !!element && element.classList.remove('select-line')

    if (tagName === 'TR') {
      target.parentNode.parentNode.className = 'select-line'
    }

    if (tagName === 'TBODY') {
      target.parentNode.className = 'select-line'
    }
  }

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left'
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])

  const handleOnBlur = (currentValue: string, oldValue: number) => {
    if (removeCurrencyMask(currentValue) !== oldValue && !isCurrentDate) {
      handleUpdateGrowthWanted(
        data['plan-otb-id'],
        removeCurrencyMask(currentValue)
      )
      updatedFinalStorage(currentValue, data)
    }
  }

  const handleOnFocus = (oldValue: number) => {
    if (isCurrentDate) {
      handleUpdateGrowthWanted(
        data['plan-otb-id'],
        removeCurrencyMask(String(oldValue)),
        true
      )
      toast({
        title: 'Aviso.',
        description: 'Não é possível alterar os parâmetros do mês atual',
        status: 'warning',
        duration: 3000,
        isClosable: true,
        position: 'top-right'
      })
    }
  }

  return (
    <tr
      className={'show-icon'}
      onClick={({ target }) => handleLineSelect(target)}
    >
      {rows.map(({ id, value, align }, key) => (
        <td
          id={id}
          key={`${id}-${key + 1}`}
          align={align || 'left'}
          className={
            id === 'indicadores-estoque-final-ajust-id'
              ? 'custom td-element'
              : 'td-element'
          }
          style={{
            padding: id === 'indicadores-estoque-final-ajust-id' && 0,
            paddingRight: id === 'indicadores-estoque-final-ajust-id' && 2,
            background: id === 'indicadores-estoque-final-ajust-id' && '#FEFFC7'
          }}
        >
          {id === 'indicadores-estoque-final-ajust-id' ? (
            <Box
              contentEditable={!data.disabled}
              onBlurCapture={e =>
                handleOnBlur(e.currentTarget.textContent, value)
              }
              onFocusCapture={() => handleOnFocus(value)}
              css={{
                paddingLeft: 12
              }}
            >
              {parseCurrency({ value: value, country: 'pt-br' })}
            </Box>
          ) : (
            <Box>
              {query.length > 0 ? (
                <Highlighter
                  searchWords={String(query).split(' ')}
                  textToHighlight={String(value)}
                />
              ) : (
                value
              )}
            </Box>
          )}
        </td>
      ))}
    </tr>
  )
}
